import {
  Info as InfoIcon,
  Danger as DangerIcon,
  Checkmark as CheckmarkIcon,
  WarningTriangle as WarningTriangleIcon,
  ExclamationMark as ExclamationMarkIcon,
} from "@rshbintech.dboul/icons";
import { NotificationType } from "./types";

export const NOTIFICATION_TYPES = {
  DEFAULT: "default",
  PRIMARY: "primary",
  IMPORTANT: "important",
  WARNING: "warning",
  DANGER: "danger",
  INFORMATIVE: "informative",
} as const;

export const NOTIFICATION_ICONS: Record<NotificationType, JSX.Element | null> =
  {
    default: null,
    primary: <CheckmarkIcon type="primary" />,
    important: <ExclamationMarkIcon type="important" />,
    warning: <WarningTriangleIcon type="warning" />,
    danger: <DangerIcon type="danger" />,
    informative: <InfoIcon type="info" />,
  };
